module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar-nav', [_c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n        ")], 1)], 1), _vm._v(" "), _c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-brand', [_c('h3', [_vm._v(_vm._s(_vm.clientName))])]), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.companyType))]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.getData
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-2 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Enquiry")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.totalEnq) + "\n                      ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Total Executions")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.totalExec) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-1"
  }, [_c('span', {
    staticClass: "text-muted ml-3 mr-2",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("FF-" + _vm._s(_vm.totalFF) + ",")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted mr-2"
  }, [_vm._v("CC-" + _vm._s(_vm.totalCC) + ",")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("TPT-" + _vm._s(_vm.totalTPT))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Container Shipped")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.totalContainerShiped) + "\n                      ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('b-card', {
    staticStyle: {
      "height": "220px"
    }
  }, [_c('b-card-text', [_c('div', [_c('h5', {
    staticClass: "card-title mt-3"
  }, [_vm._v("Executions By Modules")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-left": "-35px"
    },
    attrs: {
      "type": "pie",
      "width": "350",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  }) : _vm._e()], 1)])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [_c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Freight Revenue")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0 ml-3 mr-1"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountINR) + " ,\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0 mr-1"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountUSD) + " ,\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountEURO) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0 ml-3 mr-1"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountAED) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0 mr-1"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountGBP) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountZAR) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0 ml-3 mr-1"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountCAD) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "card-title text-muted font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.FFfinalAmountJOD) + "\n                      ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Custom Revenue")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                      " + _vm._s(_vm.CustomRevenue) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Transport Revenue")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                      " + _vm._s(_vm.TPTRevenue) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Total Revenue")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_c('h4', [_vm._v("₹ " + _vm._s(_vm.totalRevenueDefaultINR))])])]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1",
      modifiers: {
        "collapse-1": true
      }
    }],
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1"
    }
  }, [_c('div', {
    staticClass: "fluid-container mt-2"
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('b-button', {
    staticClass: "pull-right ml-3 ml-3",
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "90px",
      "padding": "10px",
      "background": "#f8f9fa",
      "border-radius": "0rem"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.USDRates),
      callback: function($$v) {
        _vm.USDRates = $$v
      },
      expression: "USDRates"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "card-title font-weight-bold mb-0 mt-1 ml-2"
  }, [_c('small', [_vm._v(_vm._s(_vm.finalAmountUSD))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('b-button', {
    staticClass: "pull-right ml-3",
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "90px",
      "padding": "10px",
      "background": "#f8f9fa",
      "border-radius": "0rem"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.EURORates),
      callback: function($$v) {
        _vm.EURORates = $$v
      },
      expression: "EURORates"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "card-title font-weight-bold mb-0 ml-2 mt-1"
  }, [_c('small', [_vm._v(_vm._s(_vm.finalAmountEURO))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('b-button', {
    staticClass: "pull-right ml-3",
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "90px",
      "padding": "10px",
      "background": "#f8f9fa",
      "border-radius": "0rem"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.ZARRates),
      callback: function($$v) {
        _vm.ZARRates = $$v
      },
      expression: "ZARRates"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "card-title font-weight-bold mb-0 ml-2 mt-1"
  }, [_c('small', [_vm._v(_vm._s(_vm.finalAmountZAR))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('b-button', {
    staticClass: "pull-right ml-3",
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "90px",
      "padding": "10px",
      "background": "#f8f9fa",
      "border-radius": "0rem"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.CADRates),
      callback: function($$v) {
        _vm.CADRates = $$v
      },
      expression: "CADRates"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "card-title font-weight-bold mb-0 ml-2 mt-1"
  }, [_c('small', [_vm._v(_vm._s(_vm.finalAmountCAD))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('b-button', {
    staticClass: "pull-right ml-3",
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "90px",
      "padding": "10px",
      "background": "#f8f9fa",
      "border-radius": "0rem"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.GBPRates),
      callback: function($$v) {
        _vm.GBPRates = $$v
      },
      expression: "GBPRates"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "card-title font-weight-bold mb-0 ml-2 mt-1"
  }, [_c('small', [_vm._v(_vm._s(_vm.finalAmountGBP))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('b-button', {
    staticClass: "pull-right ml-3",
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "90px",
      "padding": "10px",
      "background": "#f8f9fa",
      "border-radius": "0rem"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.JODRates),
      callback: function($$v) {
        _vm.JODRates = $$v
      },
      expression: "JODRates"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "card-title font-weight-bold mb-0 ml-2 mt-1"
  }, [_c('small', [_vm._v(_vm._s(_vm.finalAmountJOD))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('b-button', {
    staticClass: "pull-right ml-3",
    staticStyle: {
      "padding": "0.5rem 0.5rem",
      "font-size": "0.7rem",
      "line-height": "1",
      "border-radius": "0rem",
      "margin-right": "0px"
    },
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.getData
    }
  }, [_vm._v("Calculate")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "90px",
      "padding": "10px",
      "background": "#f8f9fa",
      "border-radius": "0rem"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.AEDRates),
      callback: function($$v) {
        _vm.AEDRates = $$v
      },
      expression: "AEDRates"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "card-title font-weight-bold mb-0 ml-2 mt-1"
  }, [_c('small', [_vm._v(_vm._s(_vm.finalAmountAED))])])], 1)])])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [_c('div', {
    staticClass: "col-md-7 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.chartOptionsConBar,
      "series": _vm.seriesConBar
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.chartOptionsShipBar.xaxis.categories.length > 0) ? _c('div', {
    staticClass: "col-md-5 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Line")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 with No.of container Shipped\n              ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.chartOptionsShipBar,
      "series": _vm.seriesShipBar
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [(_vm.topDestinationExportData.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Export Destination")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 with No.of container Shipped\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "template-demo"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', _vm._l((_vm.topDestinationExportData), function(item4, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item4.exportDesti))]), _vm._v(" "), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item4.sumOfContainerExportDestination))])], 1)])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.topDestinationImportData.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card topFiveHeight"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Import Destination")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 with No.of container Shipped\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "template-demo"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', _vm._l((_vm.topDestinationImportData), function(item5, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item5.importDesti))]), _vm._v(" "), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item5.sumOfContainerImportDestination))])], 1)])
  }))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [(_vm.topCommodityExportData.length > 0) ? _c('div', {
    staticClass: "col-md-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Most Exported Commodity")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("Top 5 (Sea)")]), _vm._v(" "), _c('div', {
    staticClass: "template-demo"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', _vm._l((_vm.topCommodityExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item3.commodiExport))]), _vm._v(" "), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item3.totalCountCommodity))])], 1)])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.chartOptionsExCom.xaxis.categories.length > 0) ? _c('div', {
    staticClass: "col-md-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "340px"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Most Exported Commodity")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("Top 5 (Sea)")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.chartOptionsExCom,
      "series": _vm.seriesExCom
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [(_vm.chartOptionstopAirline.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Top 5 Airlines Used")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("Export")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "240",
      "options": _vm.chartOptionstopAirline,
      "series": _vm.seriestopAirline
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.chartOptionsDeparture.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Top Departure Airports Export")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 with No.of Packages Shipped (Air)\n              ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart55"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "240",
      "options": _vm.chartOptionsDeparture,
      "series": _vm.seriesDeparture
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.chartOptionsArrive.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card topFiveHeight"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Top Arrival Airports Import")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 No.of Packages (Air)\n              ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart22"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "240",
      "options": _vm.chartOptionsArrive,
      "series": _vm.seriesArrive
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  })], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fce6952","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/specificClientReports.vue
// module id = 2395
// module chunks = 0